<template>
  <va-card :title="$t('menu.vehicle_bays') + ' ' + this.$route.params.order.code">
    <div class="row">
      <div class="flex xs2">
        <va-button
          medium
          inline
          color="#ff842b"
          text-align="left"
          icon="fa fa-chevron-left"
          class="ma-2"
          :to="{ name: 'quarantine', params: {
            current_page: this.$route.params.current_page, 
            search: this.$route.params.search, 
            delivery_date: this.$route.params.delivery_date, 
            perPage: this.$route.params.perPage }
          }"
        >
          {{ $t("menu.show_palletization_back") }}
        </va-button>
      </div>

      <div class="flex xs2">
        <va-toggle
          medium
          v-model="enabled"
          color="secondary"
          label="Editar"
          v-if="status === 'Carregamento'"
        />
      </div>
      <div class="flex xs2">
        <va-button
          medium
          inline
          color="secondary"
          icon="fa fa-save"
          class="ma-0"
          @click="save(vehicleBay, orderId)"
          :disabled="!enabled"
          v-if="status === 'Carregamento'"
        >
          {{ $t('menu.save') }}
        </va-button>
      </div>

      <!-- <div v-show="!loading" class="flex xs12 md12">
        <va-card>
          <div class="row row-separated">
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.productsWeight }}</p>
              <p class="text--center mb-1">{{$t('dashboard.info.productsWeight')}}</p>
            </div>
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.weightCapacity }}</p>
              <p class="text--center no-wrap mb-1">{{$t('dashboard.info.vehicleWeightCapacity')}}</p>
            </div>
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.volumeCapacity }}</p>
              <p class="text--center no-wrap mb-1">{{$t('dashboard.info.vehicleVolumeCapacity')}}</p>
            </div>
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.cubageCapacity }}</p>
              <p class="text--center no-wrap mb-1">{{$t('dashboard.info.vehicleCubageCapacity')}}</p>
            </div>
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.quantityProducts }}</p>
              <p class="text--center mb-1">{{$t('dashboard.info.quantityProducts')}}</p>
            </div>
            <div class="flex xs2">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.secondary}">{{ this.quantityClients }}</p>
              <p class="text--center mb-1">{{$t('dashboard.info.quantityClients')}}</p>
            </div>
          </div>
        </va-card>
      </div> -->

    </div>

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <div v-show="!loading" class="row">
      <div class="flex xs4 lg4">
        <div
          class="grid__container flex-center xs12"
          :style="dragStyle"
        >

          <div class="flex-center">
            {{ $t("lists.bay_label") }} {{ this.bay.name }}
          </div>

        </div>
        <div
          class="flex xs12"
        >
          <va-select
            :label="$t('forms.selects.selectPalletType')"
            v-model="pallet_type"
            keyBy="id"
            textBy="name"
            :options="palletTypes"
            :disabled="!enabled"
          />

        </div>
            <!-- <div slot="body"> -->
              <div
                v-for="(layer, i) in vehicleBay.layers"
                :key="i"
              >
                <div
                  class="grid__container flex-center"
                  :style="dragStyleAlpha"
                >
                  {{ $t("lists.layer") }} {{ layer.layer }} |
                  {{ (layer.layer_percentage * 100).toFixed(2) + '%' }}
                </div>

                <draggable
                  class="list-group"
                  :list="layer.products"
                  group="bays"
                  :disabled="!enabled"
                  @change="calcPercentLayer"
                >
                  <div
                    :style="dragProducts"
                    v-for="product in layer.products"
                    :key="product.id"
                    onMouseOver="this.style.background='#C0C0C0'"
                    onMouseOut="this.style.background='#f8f8ff'"
                  >
                    <template>
                      <va-item>
                        <div class="card_row">
                          <div class="card_column_left">
                            <div class="card_row" >
                              <va-popover
                                placement="bottom"
                                title="Detalhes do Produto"
                                :message=productDetails(product.product_name,product.ballast,product.height,product.weight,product.full_pallet)
                                color="info"
                              >
                                <img 
                                  v-bind:src=product.image
                                  height="80"
                                  width="80px"
                                />
                              </va-popover>
                            </div>
                            <div class="card_row">
                              <div class="card_column_right">
                                <va-button
                                  v-if="enabled" 
                                  inline 
                                  small 
                                  color="info"
                                  icon="fa fa-pencil"
                                  class="ma-0"
                                  @click="copyProduct(vehicleBay.id, layer.layer, product, newQuantity)"
                                >
                                  {{ $t('tables.copy') }}
                                </va-button>
                              </div>
                            </div>
                          </div>
                          <div class="card_column_right">
                            ENTREGA {{ product.delivery_sequence }}
                            <!-- <br> {{ product.client_name.length > 35 ? product.client_name.substring(0,35).concat('...') : product.client_name }} -->
                            <!-- <br> {{ product.product_name.length > 35 ? product.product_name.substring(0,35).concat('...') : product.product_name }} -->
                            <br> {{ product.product_name }}
                            <br> {{ product.quantity }} {{ product.box ? 'CX' : 'UN' }}
                            <va-input
                              v-if="enabled" 
                              v-model="newQuantity"
                              placeholder="NOVA QTD"
                            />
                          </div>
                        </div>
                      </va-item>
                    </template>
                  </div>
                </draggable>
              </div>
              <div>
                <va-button 
                  inline 
                  small 
                  color="secondary"
                  icon="fa fa-plus"
                  class="ma-1"
                  @click="addLayer(vehicleBay.id)"
                  v-if="enabled"
                >
                  {{ this.$t("tables.vehicle_bays.add_empty_layer") }}
                </va-button>
                <va-button 
                  inline 
                  small 
                  color="#ff842b"
                  icon="fa fa-plus"
                  class="ma-1"
                  @click="removeLayer(vehicleBay.id)"
                  v-if="enabled"
                >
                  {{ this.$t("tables.vehicle_bays.remove_empty_layer") }}
                </va-button>
              </div>
            <!-- </div> -->
          <!-- </va-collapse>
        </va-accordion> -->
      </div>
      <div class="flex xs4 lg4" v-if="quarantine_resolved != true">
        <div
          class="grid__container flex-center"
          :style="dragStyle"
        >

          <div>
            {{ this.$t("tables.vehicle_bays.external_bay") }}
          </div>

        </div>

            <!-- <span slot="header" style="text-align: center; font-weight: bold">
              Baia Externa
            </span> -->

            <!-- <div slot="body"> -->

              <div>
                <div
                  class="grid__container flex-center"
                  :style="dragStyleAlpha"
                >
                  {{ this.$t("menu.products") }} 
                </div>

                <draggable
                  class="list-group"
                  :list="externalBay"
                  group="bays"
                  :disabled="!enabled"
                  @change="calcPercentLayer"
                >
                  <div
                    class="list-group-item"
                    v-for="product in externalBay"
                    :key="product.id"
                  >
                    <template>
                      <va-item>
                        <div class="card_row">
                          <div class="card_column_left">
                            <div class="card_row">
                              <va-popover
                                placement="bottom"
                                title="Detalhes do Produto"
                                :message=productDetails(product.product_name,product.ballast,product.height,product.weight)
                                color="info"
                              >
                                <img 
                                  v-bind:src=product.image
                                  height="80"
                                  width="80px"
                                />
                              </va-popover>
                            </div>
                            <!-- <div class="card_row">
                              <div class="card_column_right">
                                <va-button
                                  v-if="enabled" 
                                  inline 
                                  small 
                                  color="info"
                                  icon="fa fa-pencil"
                                  class="ma-0"
                                  @click="copyProduct(bay.id, layer.layer, product, newQuantity)"
                                >
                                  {{ $t('tables.copy') }}
                                </va-button>
                              </div>
                            </div> -->
                          </div>
                          <div class="card_column_right">
                            ENTREGA {{ product.delivery_sequence }}
                            <!-- <br> {{ product.client_name.length > 20 ? product.client_name.substring(0,20).concat('...') : product.client_name }} -->
                            <br> {{ product.product_name.length > 20 ? product.product_name.substring(0,20).concat('...') : product.product_name }}
                            <br> {{ product.quantity }} CX
                            <!-- <va-input
                              v-if="enabled" 
                              v-model="newQuantity"
                              placeholder="NOVA QTD"
                            /> -->
                          </div>
                        </div>
                      </va-item>
                    </template>
                  </div>
                </draggable>
              </div>
            <!-- </div>
          </va-collapse>
        </va-accordion> -->
      </div>
    </div>
  </va-card> 
</template>

<script>
import ManualSortedProductAPI from '@/services/ManualSortedProductAPI'
import OrdersAPI from '@/services/OrdersAPI'
import PalletTypeAPI from '@/services/PalletTypeAPI'
import draggable from 'vuedraggable'
import * as spinners from 'epic-spinners'

export default {
  name: 'grid',
  components: {
    draggable,
    ...spinners,
  },
  data () {
    return {
      data: [],
      orderId: '',
      status: '',
      enabled: false,
      loading: false,
      collapse: false,
      config: {
        size: 150,
        group: 4,
        duration: 3000,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 3000,
      vehicleBay: {
        id: '',
        bay_name: '',
        bay_type_name: '',
        height: '',
        length: '',
        load_id: '',
        pallet_type: {
          id: '',
          name: ''
        },
        width: '',
        layers: [],
      },
      productsWeight: '',
      quantityProducts: '',
      quantityClients: '',
      weightCapacity: '',
      volumeCapacity: '',
      cubageCapacity: '',
      newQuantity: '',
      externalBay: [],
      loadStatus: '',
      validate: '',
      palletTypes: [],
      pallet_type: '',
      layer_percentage: '',
      bay: {
        name: ''
      },
      quarantine_resolved: '',
      dragStyle: {
        backgroundColor: this.$themes.secondary,
        fontWeight: 'bold'
      },
      dragStyleAlpha: {
        backgroundColor: this.$themes.secondary,
        fontWeight: 'bold',
        opacity: 0.3
      },
      dragProducts: {
        backgroundColor: '#f8f8ff',
        cursor: 'grab',
        marginTop: '5px',
        borderRadius: '10px',
      }
    }
  },
  mounted () {
    this.readItems()
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    spload () {
      return spinners.SelfBuildingSquareSpinner
    },
  },
  methods: {
    readItems() {

      this.orderId = this.$route.params.order.id
      this.loading = true

      OrdersAPI.getOrder(this.orderId).then(
        response => {
          this.quarantine_resolved = response.data.order.quarantine_resolved

          if (this.quarantine_resolved == false) {
            OrdersAPI.getBayProductsOrder(this.orderId).then(
              response => {
                this.bay.name = response.data.bay_name
                this.pallet_type = response.data.pallet_type.name
                this.productsWeight = response.data.products_weight
                this.quantityProducts = response.data.quantity_products
                this.quantityClients = response.data.quantity_clients
                this.weightCapacity = response.data.vehicle_weight_capacity
                this.volumeCapacity = response.data.vehicle_volume_capacity
                this.cubageCapacity = response.data.vehicle_cubage_capacity
                this.loading = false
                this.status = response.data.status
                this.loading = false

                this.vehicleBay.id = response.data.bay_id
                this.vehicleBay.bay_name = response.data.bay_name
                this.vehicleBay.bay_type_name = response.data.bay_type_name
                this.vehicleBay.height = response.data.height
                this.vehicleBay.length = response.data.length
                this.vehicleBay.load_id = response.data.load_id
                this.vehicleBay.width = response.data.width

                this.vehicleBay.pallet_type.id = response.data.pallet_type.id
                this.vehicleBay.pallet_type.name = response.data.pallet_type.name

                this.vehicleBay.layers = response.data.layers
              }
            )
          } else {
            OrdersAPI.getBayProductsOrderSortedManual(this.orderId).then(
              response => {
                this.bay.name = response.data.bay_name
                this.pallet_type = response.data.pallet_type.name
                this.productsWeight = response.data.products_weight
                this.quantityProducts = response.data.quantity_products
                this.quantityClients = response.data.quantity_clients
                this.weightCapacity = response.data.vehicle_weight_capacity
                this.volumeCapacity = response.data.vehicle_volume_capacity
                this.cubageCapacity = response.data.vehicle_cubage_capacity
                this.loading = false
                this.status = ""

                this.vehicleBay.id = response.data.bay_id
                this.vehicleBay.bay_name = response.data.bay_name
                this.vehicleBay.bay_type_name = response.data.bay_type_name
                this.vehicleBay.height = response.data.height
                this.vehicleBay.length = response.data.length
                this.vehicleBay.load_id = response.data.load_id
                this.vehicleBay.width = response.data.width

                this.vehicleBay.pallet_type.id = response.data.pallet_type.id
                this.vehicleBay.pallet_type.name = response.data.pallet_type.name

                this.vehicleBay.layers = response.data.layers

              }
            )
          }
        }
      )

      PalletTypeAPI.getAll().then( response => {
        this.palletTypes = response.data.pallet_types
      })
      
    },
    productDetails(name, ballast, height, weight, fullPallet) {
      return 'L: ' + ballast + 'cx' + ', A: ' + height + 'cm' + ', P:' + weight + 'Kg' + ' PC: ' + fullPallet + 'cx'
    },
    addLayer(bay_id) {
      if (this.vehicleBay.id === bay_id) {
        if (this.vehicleBay.layers.length === 0) {
          var new_layer = 1
        } else {
          var new_layer = this.vehicleBay.layers[this.vehicleBay.layers.length - 1].layer + 1
        }
        this.vehicleBay.layers.push({ layer: new_layer, layer_percentage: 0, products: [] })
      }
    },
    removeLayer(bay_id) {
      if (this.vehicleBay.id === bay_id) {
        this.vehicleBay.layers.forEach(bay_layer => {
          if (bay_layer.products.length === 0){
            this.vehicleBay.layers.splice(this.vehicleBay.layers.indexOf(bay_layer), 1);
          }
        });
        this.vehicleBay.layers.forEach(bay_layer => {
          bay_layer.layer = this.vehicleBay.layers.indexOf(bay_layer) + 1;
        });
      }
    },
    copyProduct(bay_id, layer, manual_sorted_product, newQuantity) {
      var new_product = []
      if (this.vehicleBay.id === bay_id) {
        this.vehicleBay.layers.forEach(bay_layer => {
          if (bay_layer.layer === layer){
            bay_layer.products.forEach(product => {
              if (product.id === manual_sorted_product.id) {
                new_product = {
                  id: product.id,
                  quantity: newQuantity,
                  delivery_sequence: product.delivery_sequence,
                  product_percentage: (newQuantity / product.ballast),
                  layer_picker: product.layer_picker,
                  box: product.box,
                  product_id: product.product_id,
                  product_name: product.product_name,
                  image: product.image,
                  quantity: newQuantity,
                  package_name: product.package_name,
                  ballast: product.ballast,
                  height: product.height,
                  weight: product.weight
                }
                var product_quantity = product.quantity - newQuantity
                product.quantity = product_quantity
                product.product_percentage = (product_quantity / product.ballast)
              }
            })
            this.externalBay.push(new_product)
          }
        })
        this.newQuantity = ''
        this.calcPercentLayer()
      }
    },
    calcPercentLayer() {
      this.vehicleBay.layers.forEach(layer => {
        var layerPercentage = 0
          layer.products.forEach(product => {
            layerPercentage += product.product_percentage
          });
        layer.layer_percentage = layerPercentage
      });
    },
    save(data, orderId) {
      this.verifyData()

      if (this.validate) {

        this.enabled = false
        this.loading = true

        ManualSortedProductAPI.saveManualPalletizedProducts(data, orderId).then(response => {
        
          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })

          this.readItems()
          
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      } else {
        this.showToast(this.$t('toast.unableToSavePalletization'), {
          icon: 'fa-exclamation',
          position: 'top-right',
        })
      }
    },
    verifyData() {

      this.validate = true

      for (let layer of this.vehicleBay.layers) {
        if (layer.layer_percentage > 1) {
          this.showToast(this.$t('toast.layerPercentageAbove100'), {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
          this.validate = false
          break;
        } else if (layer.length === 0) {
          this.showToast(this.$t('toast.layerWithoutProduct'), {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
          this.validate = false
          break;
        }
        for (let product of layer.products) {
          if (product.quantity === 0) {
            this.showToast(this.$t('toast.productWithZeroQuantity'), {
              icon: 'fa-thumbs-o-down',
              position: 'top-right',
            })
            this.validate = false
            break;
          }
        }
      }
      if (this.externalBay.length > 0) {
        this.showToast(this.$t('toast.productsInTheOuterBay'), {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
        })
        this.validate = false
      }
    }
  },
}
</script>
 
<style lang="scss">
  // .list-group-item {
  //   cursor: grab;
  //   background-color: #f8f8ff;
  //   margin-top: 5px;
  //   border-radius: 10px;
  // }

  // .list-group-item :hover {
  //   background-color: #CB022A;
  //   color: #fff;
  //   border-radius: 10px;
  // }

  .list-group-item i {
    // cursor: grabbing;
  }
  .bold {
    font-weight: bold;
  }
  .card_column {
    float: left;
    width: 50%;
  }
  .card_column_left {
    float: left;
    width: 35%;
  }
  .card_column_right {
    float: left;
    width: 65%;
  }
  /* Clear floats after the columns */
  .card_row:after {
    content: "";
    display: table;
    clear: both;
  }
</style>
